/**
 * 產生梯次通行碼的用戶端工具。
 *
 * 字母表必須與 functions/src/inventoryAccessCodes.ts 保持一致：那邊負責驗證，
 * 這邊負責產生，兩邊用不同的字母表會直接讓通行碼對不上。
 */
export const ACCESS_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export const ACCESS_CODE_LENGTH = 4;

/**
 * 用 crypto.getRandomValues 產生通行碼；測試時可注入固定的位元組序列。
 * 沒有取模偏差的問題：32 個字元剛好整除 256。
 */
export const generateInventoryAccessCode = (randomBytes?: Uint8Array): string => {
  const bytes = randomBytes ?? crypto.getRandomValues(new Uint8Array(ACCESS_CODE_LENGTH));

  if (bytes.length < ACCESS_CODE_LENGTH) {
    throw new Error(`generateInventoryAccessCode needs at least ${ACCESS_CODE_LENGTH} random bytes.`);
  }

  let code = '';
  for (let i = 0; i < ACCESS_CODE_LENGTH; i++) {
    code += ACCESS_CODE_ALPHABET[bytes[i] % ACCESS_CODE_ALPHABET.length];
  }
  return code;
};
